/**
 * Lourmel Repostería — Shopify Theme JavaScript
 * Adapted from the original static site script.js
 */

(function () {
  'use strict';

  /* ═══════════════════════════════════════
     ANNOUNCEMENT BAR
     ═══════════════════════════════════════ */
  const announcementBar = document.getElementById('announcement-bar');
  const announcementClose = document.getElementById('announcement-close');

  if (announcementClose && announcementBar) {
    // Check if previously dismissed
    if (sessionStorage.getItem('announcement-dismissed') === 'true') {
      announcementBar.style.display = 'none';
    }
    announcementClose.addEventListener('click', () => {
      announcementBar.style.display = 'none';
      sessionStorage.setItem('announcement-dismissed', 'true');
    });
  }

  /* ═══════════════════════════════════════
     HEADER — Sticky + Shrink on Scroll
     ═══════════════════════════════════════ */
  const header = document.getElementById('header');
  let lastScroll = 0;

  if (header) {
    window.addEventListener('scroll', () => {
      const current = window.scrollY;
      header.classList.toggle('scrolled', current > 60);

      // Hide/show on scroll direction
      if (current > lastScroll && current > 300) {
        header.style.transform = 'translateY(-100%)';
      } else {
        header.style.transform = 'translateY(0)';
      }
      lastScroll = current;
    }, { passive: true });
  }

  /* ═══════════════════════════════════════
     MOBILE NAV TOGGLE
     ═══════════════════════════════════════ */
  const navToggle = document.getElementById('nav-toggle');
  const navLinks = document.getElementById('nav-links');

  if (navToggle && navLinks) {
    navToggle.addEventListener('click', () => {
      const expanded = navToggle.getAttribute('aria-expanded') === 'true';
      navToggle.setAttribute('aria-expanded', !expanded);
      navToggle.classList.toggle('active');
      navLinks.classList.toggle('open');
      document.body.style.overflow = expanded ? '' : 'hidden';
    });

    // Close nav when clicking a link
    navLinks.querySelectorAll('.nav-link').forEach(link => {
      link.addEventListener('click', () => {
        navToggle.setAttribute('aria-expanded', 'false');
        navToggle.classList.remove('active');
        navLinks.classList.remove('open');
        document.body.style.overflow = '';
      });
    });
  }

  /* ═══════════════════════════════════════
     HERO — Rotating background photos
     ═══════════════════════════════════════ */
  const heroSlides = document.querySelectorAll('.hero-slide-bg');
  const heroIndicators = document.querySelectorAll('.hero-indicators .indicator');
  const heroSection = document.getElementById('hero-section');
  const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  if (heroSlides.length > 1) {
    let currentSlide = 0;
    let heroTimer = null;

    const goToSlide = (index) => {
      heroSlides[currentSlide].classList.remove('active');
      heroIndicators[currentSlide] && heroIndicators[currentSlide].classList.remove('active');
      currentSlide = index;
      heroSlides[currentSlide].classList.add('active');
      heroIndicators[currentSlide] && heroIndicators[currentSlide].classList.add('active');
    };

    const nextSlide = () => goToSlide((currentSlide + 1) % heroSlides.length);

    const startHeroTimer = () => {
      clearInterval(heroTimer);
      if (prefersReducedMotion) return;
      heroTimer = setInterval(nextSlide, 5500);
    };

    const stopHeroTimer = () => clearInterval(heroTimer);

    heroIndicators.forEach((dot, index) => {
      dot.addEventListener('click', () => {
        goToSlide(index);
        startHeroTimer();
      });
    });

    if (heroSection) {
      heroSection.addEventListener('mouseenter', stopHeroTimer);
      heroSection.addEventListener('mouseleave', startHeroTimer);
      heroSection.addEventListener('focusin', stopHeroTimer);
      heroSection.addEventListener('focusout', startHeroTimer);
    }

    startHeroTimer();
  }

  /* ═══════════════════════════════════════
     HERO — Parallax sutil en scroll
     ═══════════════════════════════════════ */
  const heroSlidesEl = document.querySelector('.hero-slides');

  if (heroSlidesEl && heroSection && !prefersReducedMotion) {
    let parallaxTicking = false;

    const applyParallax = () => {
      const rect = heroSection.getBoundingClientRect();
      if (rect.bottom > 0 && rect.top < window.innerHeight) {
        heroSlidesEl.style.transform = `translateY(${rect.top * -0.08}px)`;
      }
      parallaxTicking = false;
    };

    window.addEventListener('scroll', () => {
      if (!parallaxTicking) {
        requestAnimationFrame(applyParallax);
        parallaxTicking = true;
      }
    }, { passive: true });

    applyParallax();
  }

  /* ═══════════════════════════════════════
     SEARCH OVERLAY
     ═══════════════════════════════════════ */
  const searchToggle = document.getElementById('search-toggle');
  const searchOverlay = document.getElementById('search-overlay');
  const searchClose = document.getElementById('search-close');
  const searchInput = document.getElementById('search-input');

  if (searchToggle && searchOverlay) {
    searchToggle.addEventListener('click', () => {
      searchOverlay.classList.add('open');
      searchOverlay.setAttribute('aria-hidden', 'false');
      if (searchInput) searchInput.focus();
    });

    if (searchClose) {
      searchClose.addEventListener('click', () => {
        searchOverlay.classList.remove('open');
        searchOverlay.setAttribute('aria-hidden', 'true');
      });
    }

    document.addEventListener('keydown', e => {
      if (e.key === 'Escape' && searchOverlay.classList.contains('open')) {
        searchOverlay.classList.remove('open');
        searchOverlay.setAttribute('aria-hidden', 'true');
      }
    });
  }

  /* ═══════════════════════════════════════
     BACK TO TOP
     ═══════════════════════════════════════ */
  const backToTop = document.getElementById('back-to-top');
  if (backToTop) {
    window.addEventListener('scroll', () => {
      backToTop.classList.toggle('visible', window.scrollY > 500);
    }, { passive: true });

    backToTop.addEventListener('click', () => {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });
  }

  /* ═══════════════════════════════════════
     VIDEOS Y REELS — clic para reproducir con sonido
     ═══════════════════════════════════════ */
  function initVideoReels() {
    const items = document.querySelectorAll('.video-item');
    if (!items.length) return;

    const stopItem = (item) => {
      const video = item.querySelector('.video-item-player');
      if (!video) return;
      video.pause();
      video.muted = true;
      video.controls = false;
      item.classList.remove('playing');
    };

    const playItem = (item) => {
      const video = item.querySelector('.video-item-player');
      if (!video) return;
      items.forEach(other => { if (other !== item) stopItem(other); });
      video.muted = false;
      video.controls = true;
      item.classList.add('playing');
      video.play();
    };

    items.forEach(item => {
      const playBtn = item.querySelector('.video-item-play');
      const video = item.querySelector('.video-item-player');
      if (playBtn) {
        playBtn.addEventListener('click', () => playItem(item));
      }
      if (video) {
        video.addEventListener('ended', () => stopItem(item));
      }
    });
  }

  initVideoReels();

  /* ═══════════════════════════════════════
     SCROLL REVEAL ANIMATIONS
     ═══════════════════════════════════════ */
  let revealObserver = null;

  function initReveal(scope) {
    const elements = (scope || document).querySelectorAll('.reveal:not(.visible)');
    if (!elements.length) return;

    if ('IntersectionObserver' in window) {
      if (!revealObserver) {
        revealObserver = new IntersectionObserver((entries) => {
          entries.forEach(entry => {
            if (entry.isIntersecting) {
              entry.target.classList.add('visible');
              revealObserver.unobserve(entry.target);
            }
          });
        }, { threshold: 0.15, rootMargin: '0px 0px -60px 0px' });
      }
      elements.forEach(el => revealObserver.observe(el));
    } else {
      elements.forEach(el => el.classList.add('visible'));
    }
  }

  initReveal(document);

  // Re-inicializar cuando el editor de Shopify carga una sección dinámicamente
  document.addEventListener('shopify:section:load', function (event) {
    initReveal(event.target);
  });

  /* ═══════════════════════════════════════
     TOAST NOTIFICATION
     ═══════════════════════════════════════ */
  window.showToast = function (message, type = 'success', duration = 3500) {
    const toast = document.getElementById('toast');
    if (!toast) return;
    toast.textContent = message;
    toast.className = 'toast show ' + type;
    clearTimeout(toast._timer);
    toast._timer = setTimeout(() => {
      toast.classList.remove('show');
    }, duration);
  };

  /* ═══════════════════════════════════════
     SIDEBAR TOGGLE (Catalog page, mobile)
     ═══════════════════════════════════════ */
  const sidebarToggle = document.getElementById('sidebar-toggle');
  const sidebarInner = document.getElementById('sidebar-inner');

  if (sidebarToggle && sidebarInner) {
    sidebarToggle.addEventListener('click', () => {
      const expanded = sidebarToggle.getAttribute('aria-expanded') === 'true';
      sidebarToggle.setAttribute('aria-expanded', !expanded);
      sidebarInner.classList.toggle('open');
    });
  }

  /* ═══════════════════════════════════════
     SIDEBAR SECTION TOGGLES (Filters)
     ═══════════════════════════════════════ */
  document.querySelectorAll('.sidebar-section-toggle').forEach(toggle => {
    toggle.addEventListener('click', () => {
      const expanded = toggle.getAttribute('aria-expanded') === 'true';
      toggle.setAttribute('aria-expanded', !expanded);
      const target = document.getElementById(toggle.dataset.target);
      if (target) {
        target.style.display = expanded ? 'none' : '';
      }
    });
  });

  /* ═══════════════════════════════════════
     PRODUCT IMAGE THUMBNAILS (Product page)
     ═══════════════════════════════════════ */
  document.querySelectorAll('.product-thumbnail').forEach(thumb => {
    thumb.addEventListener('click', () => {
      const mainImage = document.getElementById('product-img');
      if (mainImage && thumb.dataset.imageUrl) {
        mainImage.src = thumb.dataset.imageUrl;
        // Update active state
        document.querySelectorAll('.product-thumbnail').forEach(t => t.classList.remove('active'));
        thumb.classList.add('active');
      }
    });
  });

})();
